/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'apiKeyEdit.title', 'defaultMessage': 'Edit API Key'}
});

interface ApiKeyEditProps {
    intl: IntlShape;
    user: User;
}

class ApiKeyEdit extends React.Component<ApiKeyEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    static contextTypes = {
        router: PropTypes.object
    };

    typeName = 'apiKeys';

    constructor() {
        super();
    }

    _onSuccess = () => {
        let url = urlMapping.getUrl(types['apiKeys'], 'view', {organisation_id: this.props.user.organisation.realId, ...this.props.user.apiKey});
        this.context.router.push(url);
    };

    render() {
        let { apiKey } = this.props.user;

        let type = types[this.typeName];
        /* fake organisation_id to allow our URL system to work */
        apiKey['organisation_id'] = this.props.user.organisation.realId;

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)} titleAsHeader>
                <Editor
					cancelable
                    columns={['description', 'validFrom', 'validTo']}
                    data={apiKey}
                    fatQuery={Relay.QL `fragment on UpdateApiKeyPayload {
                        updatedNode {
                            id,
                            realId,
                            user_id,
                            validFrom,
                            validTo,
                            description,
                        },
                    }`}
                    metadata={type}
                    mutation={Relay.QL `mutation { updateApiKey }`}
                    onSuccess={this._onSuccess}
                    organisationId={this.props.user.organisation.realId}
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ApiKeyEdit), (props) => {
    return props.user.apiKey;
}), {
    initialVariables: {
        apiKeyId: '',
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                firstname,
                surname,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                },
                apiKey(id: $apiKeyId) {
                    id,
                    realId,
                    apiKey,
                    user_id,
                    validFrom,
                    validTo,
                    description,
                    createdAt,
                }
            }
        `,
    },
});
